import React, { useRef } from "react";
import { useState } from "react";

const Popover = ({ title, detail, detailElement, children, index }) => {
  const [isOpen, setOpen] = useState(false);
  let timeoutRef = useRef(null);
  const [popoverClass, setPopoverClass] = useState("top-2");

  const show = () => {
    const rect = elementRef.current.getBoundingClientRect();
    const distanceFromBottom = window.innerHeight - rect.bottom;

    if (distanceFromBottom < 300) {
      setPopoverClass("bottom-full");
    } else {
      setPopoverClass("top-full");
    }
    setOpen(true);
    clearTimeout(timeoutRef.current);
  };

  const hide = () => {
    timeoutRef.current = setTimeout(() => setOpen(false), 200);
  };
  const elementRef = useRef(null);

  return (
    <div
      onMouseEnter={show}
      onMouseLeave={hide}
      className={`relative p-1 group ${isOpen ? "z-40" : "z-0"}  `}
    >
      <div className="flex justify-center items-center">
        <button
          ref={elementRef}
          id="popover-btn"
          type="button"
          className={`
      group focus:border-none focus:outline-none mr-1 mt-2`}
        >
          {children}
        </button>
        {isOpen && (
          <div
            onMouseEnter={show}
            className={`absolute  ${popoverClass} z-40 mt-3 w-[300px] sm:w-[500px] md:w-[700px]  lg:max-w-3xl bg-custom-gray-300 rounded-xl overflow-hidden shadow-lg fade-in ${"left-0"}  `}
          >
            <div className="w-full h-16 flex items-center px-4 bg-secondary  ">
              <span className="text-lg font-bold text-custom-gray-100">
                {title}
              </span>
            </div>
            <div className="p-1 max-h-80 overflow-y-auto custom-primary-tiny-scroll">
              {detailElement}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Popover;
